import RomanceGame from "@/components/RomanceGame";

export default function Game() {
  return (
    <div className="px-5 pb-28 pt-32 md:px-8 md:pt-40" data-testid="game-page">
      <RomanceGame />
    </div>
  );
}
